import { z } from "zod";

export const ChangePasswordFormSchema = z
  .object({
    lastPassword: z.string().min(1, { message: "Senha inválida" }),
    newPassword: z.string().min(1, { message: "Senha inválida" }),
    confirmNewPassword: z.string().min(1, { message: "Senha inválida" }),
  })
  .refine((data) => data.newPassword === data.confirmNewPassword, {
    message: "As senhas devem ser iguais",
    path: ["confirmNewPassword"],
  });
